<template>
    <ckeditor :editor="editor" :value="this.value" :config="editorConfig" @input="emit"></ckeditor>
</template>

<script>

const customColorPalette = [
    {
        color: 'rgb(0, 0, 0)',
        label: 'Black'
    },
    {
        color: 'rgb(77, 77, 77)',
        label: 'Dim grey'
    },
    {
        color: 'rgb(153, 153, 153)',
        label: 'Grey'
    },
    {
        color: 'rgb(230, 230, 230)',
        label: 'Light grey'
    },
    {
        color    : 'rgb(255, 255, 255)',
        label    : 'White',
        hasBorder: true
    },
    {
        color: 'rgb(230, 76, 76)',
        label: 'Red'
    },
    {
        color: 'rgb(230, 153, 76)',
        label: 'Orange'
    },
    {
        color: 'rgb(230, 230, 76)',
        label: 'Yellow'
    },
    {
        color: 'rgb(153, 230, 76)',
        label: 'Light green'
    },
    {
        color: 'rgb(76, 230, 76)',
        label: 'Green'
    },
    {
        color: 'rgb(76, 230, 153)',
        label: 'Aquamarine'
    },
    {
        color: 'rgb(76, 230, 230)',
        label: 'Turquoise'
    },
    {
        color: 'rgb(76, 153, 230)',
        label: 'Light blue'
    },
    {
        color: 'rgb(76, 76, 230)',
        label: 'Blue'
    },
    {
        color: 'rgb(153, 76, 230)',
        label: 'Purple'
    }
];

import CKEditor   from 'ckeditor4-vue';
Vue.use(CKEditor);

export default {
    components: {
        ckeditor: CKEditor.component
    },
    name      : "ckeditor-container-email",
    props     : ['value', 'options', 'mentionFrom'],
    data() {
        return {
            extraPlugins : 'widget',
            editor:CKEditor,
            editorConfig: {
                resize_enabled: false,
                removePlugins:'easyimage,image',
                extraPlugins : 'pastefromword,pastefromgdocs,uploadimage,uploadwidget,image2,widget,scayt',
                uploadUrl: '/api/ckeditor-template-resource-files',
                autoUpdateElement: true,
                allowedContent:true,
                removeButtons:'Save,NewPage,ExportPdf,Preview,Subscript,Superscript,CopyFormatting,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Scayt,SelectAll,Find,Replace,Redo,Undo,Cut,Copy,Paste,PasteText,PasteFromWord,Templates,Source,BidiLtr,BidiRtl,Language,Anchor,Unlink,Link,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Format,Font,Maximize,ShowBlocks,About,Print',
                language: 'en',
                fontSize: {
                    options: ['5px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
                },
                image: {
                    toolbar: [
                        'imageTextAlternative',
                        'imageStyle:full',
                        'imageStyle:side'
                    ]
                },
                fontBackgroundColor: {
                    colors: customColorPalette
                },
                fontColor: {
                    colors: customColorPalette
                },
                mention: {
                    feeds: [
                        {
                            marker: '@',
                            feed: this.getFeedItems,
                            minimumCharacters: 1
                        }
                    ]
                },
                toolbarGroups: [
                    { name: 'document', groups: [ 'mode', 'document' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align' ] },
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'colors', groups: [ 'colors' ] },
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] }
                ],
                contentsCss: '/css/ckeditor-sequence.css',
                scayt_autoStartup: true,
                scayt_lang: 'en'
            },
            userInput   : false,
            atValues    : [],
        }
    },
    mounted() {
        Bus.$on('mention', data => {
            this.$emit('mention', data);
        });
    },
    watch     : {
        options() {
            this.atValues = this.options.map(this.mapValues);
        },
    },
    methods   : {
        emit(value, batch) {
            this.$emit('input', value);
        },
        // onReady() {
        //     window.editor = this.editor;
        // },
        getFeedItems(queryText) {
            let values = this.atValues.filter(function (option) {
                return option.id.toUpperCase().indexOf(queryText.toUpperCase()) !== -1;
            });
            return values.slice(0, 5);
        },
        mapValues(option) {
            option.user_id = option.id;
            option.id      = `@${option[this.mentionFrom]}`;
            return option;
        },
        mentionSelected(editor) {
            editor.conversion.for('downcast').attributeToElement({
                model            : 'mention',
                view             : (modelAttributeValue, viewWriter) => {
                    if (!modelAttributeValue) {
                        return;
                    }
                    const mention = {
                        ...modelAttributeValue,
                        id: modelAttributeValue.user_id
                    }
                    Bus.$emit('mention', mention);
                },
                converterPriority: 'high'
            });
        },
    }

}

</script>

<style>
.ck-editor__editable {
    max-height: 200px;
}
</style>
